/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigValidationResponse {
    getFixupPrototypeFunction() { return ConfigValidationResponse.fixupPrototype; }

    static newInstance(model: Partial<ConfigValidationResponse>): ConfigValidationResponse {
        let obj = Object.assign(new ConfigValidationResponse(), model);
        ConfigValidationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigValidationResponse>): ConfigValidationResponse {
        if (!model) return null;
        return ConfigValidationResponse.newInstance(<ConfigValidationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigValidationResponse) {
        if (!obj) return;

        models.ConfigValidationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigValidationResponse): boolean {
        Object.setPrototypeOf(obj, ConfigValidationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.config_validations) {
            for (let val of this.config_validations) {
                models.ConfigValidationSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Status response
     */
    status: string;

    /**
     * Mandatory requirements
     */
    mandatory_requirements: { [key: string]: string; };

    /**
     * Optional requirements
     */
    optional_requirements: { [key: string]: string; };

    /**
     * Config validation results
     */
    config_validations: Array<models.ConfigValidationSummary>;

}
